import LegendAndDescription from "./legendAndEdscriptionComponents";

export default LegendAndDescription;